'use client'
import type { ButtonPillProps } from '@fortum/elemental-ui'
import { ButtonPill } from '@fortum/elemental-ui'

import { Link } from '@/i18n/navigation'
import { RichText } from '@/shared/components/RichText'
import type { HeroSectionEntry } from '@/shared/contentful/types'
import { getLinkEntryUrl } from '@/shared/contentful/utils'
import { useLocale } from '@/shared/locale'

import { BasicHeroLayout } from '../BasicHeroLayout'

export type BasicHeroProps = Omit<HeroSectionEntry, '__typename' | 'sys'>

/**
 * Hero section.
 */
export const BasicHero: React.FC<BasicHeroProps> = (props) => {
  const locale = useLocale()
  const { primaryLink, secondaryLink } = props

  const renderButton = (
    link: BasicHeroProps['primaryLink'] | BasicHeroProps['secondaryLink'],
    testId: string,
    status: ButtonPillProps['status'],
    extraProps = {},
  ) =>
    link ? (
      <ButtonPill
        tag={Link}
        href={getLinkEntryUrl(link, locale)}
        data-testid={testId}
        status={status}
        {...extraProps}
      >
        {link.label}
      </ButtonPill>
    ) : null

  const primaryButton = renderButton(primaryLink, 'hero-primary-button', 'campaign')
  const secondaryButton = renderButton(secondaryLink, 'hero-secondary-button', 'secondary', {
    invert: true,
    transparent: true,
  })

  return (
    <BasicHeroLayout
      image={props.image}
      primaryButton={primaryButton}
      secondaryButton={secondaryButton}
      title={props.title}
      subtitle={props.subtitle}
      titleSize={props.titleSize}
    >
      <RichText document={props.content} />
    </BasicHeroLayout>
  )
}
